import { useNewsNavigation } from "../utils/navigationUtils";
import { trackComponent } from "@repo/analytics";
import { componentNameConstants, dlEventConstants } from "@repo/analytics/data-layer.constants";
import { getCustomerIdForAnalytics } from "../../../utils/analytics-utils";
import {
  campaignName,
  journeyTag,
  productCategory,
  propertyType,
  referenceId,
  sprint,
  subSection,
} from "../../../pages/News/newsTrackingConstants";

interface UseNewsCardClickProps {
  newsId: string;
  onClick?: (newsId: string) => void;
  newsType?: string;
  newsHeading: string;
  componentPosition: string;
}

/**
 * Shared hook for handling news card click events
 */
export const useNewsCardClick = ({
  newsId,
  onClick,
  newsType,
  newsHeading,
  componentPosition,
}: UseNewsCardClickProps) => {
  const { navigateToNewsDetail } = useNewsNavigation();

  const handleClick = () => {
    (async () => {
      const customerId = await getCustomerIdForAnalytics();

      const isOtherNews = newsType === "otherNews" || newsType === "other_news";

      const componentName = isOtherNews
        ? componentNameConstants.NEWS_CATEGORY_LISTING
        : componentNameConstants.IPO_NEWS;

      const sectionTitle = isOtherNews ? componentNameConstants.OTHER_NEWS : componentNameConstants.TRENDING_NEWS;

      const eventType = isOtherNews
        ? dlEventConstants.NEWS_CATEGORY_LISTING_LINK_CLICK
        : dlEventConstants.IPO_NEWS_CARD_CLICK;

      await trackComponent({
        componentName,
        sectionTitle,
        eventType,
        ctaText: newsHeading,
        productCategory: productCategory,
        subSection: newsHeading,
        cleverTapOverrides: {
          EP_JOURNEY: journeyTag,
          EP_PROPERTY_TYPE: propertyType,
          EP_PRODUCT_NAME: subSection,
          EP_CAMPAIGN: campaignName,
          EP_SPRINT: sprint,
          EP_REFERENCE_ID: referenceId,
          ...(customerId && { EP_CUSTOMER_ID: customerId }),
          EP_SR_NUMBER: componentPosition,
        },
      });
    })();


    if (onClick) {
      onClick(newsId);
    } else {
      navigateToNewsDetail(newsId, newsType);
    }
  };

  return { handleClick };
};

